/**
 * @generated SignedSource<<cf539e4c123eb413ef15335fb2778266>>
 * @relayHash 65fead0219c6f8527b4c8f604d3c5f34
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7cb1a4c68604867a7f41579c7c88e541a7e555d202b956b72bce468022721cc0

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JsmProjectMenuContent_SidebarQuery$variables = {
  cloudId: string;
  projectKey: string;
};
export type JsmProjectMenuContent_SidebarQuery$data = {
  readonly jira_projectLevelSidebarMenuCustomization: {
    readonly __typename: "JiraProjectLevelSidebarMenuCustomization";
    readonly hiddenMenuItems: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly itemId: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly id: string | null | undefined;
  } | {
    readonly __typename: "QueryError";
    readonly message: string | null | undefined;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
};
export type JsmProjectMenuContent_SidebarQuery = {
  response: JsmProjectMenuContent_SidebarQuery$data;
  variables: JsmProjectMenuContent_SidebarQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "projectKey",
        "variableName": "projectKey"
      }
    ],
    "kind": "LinkedField",
    "name": "jira_projectLevelSidebarMenuCustomization",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "__typename"
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "concreteType": "JiraProjectLevelSidebarMenuItemConnection",
            "kind": "LinkedField",
            "name": "hiddenMenuItems",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraProjectLevelSidebarMenuItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraProjectLevelSidebarMenuItem",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "itemId"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ],
        "type": "JiraProjectLevelSidebarMenuCustomization"
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "kind": "ScalarField",
            "name": "message"
          }
        ],
        "type": "QueryError"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "JsmProjectMenuContent_SidebarQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "JsmProjectMenuContent_SidebarQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": "7cb1a4c68604867a7f41579c7c88e541a7e555d202b956b72bce468022721cc0",
    "metadata": {},
    "name": "JsmProjectMenuContent_SidebarQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "505475e164862129f2f16489b9059e1d";

export default node;
